import { render, staticRenderFns } from "./PlayerPage.vue?vue&type=template&id=aa18b30a&scoped=true"
import script from "./PlayerPage.vue?vue&type=script&lang=js"
export * from "./PlayerPage.vue?vue&type=script&lang=js"
import style0 from "./PlayerPage.vue?vue&type=style&index=0&id=aa18b30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa18b30a",
  null
  
)

export default component.exports